import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Loading from './Loading';

export default function Button({
                                   type = 'button',
                                   text,
                                   onClick,
                                   loading = false,
                                   disabled = false,
                                   default: isDefault,
                                   primary,
                                   white,
                                   info,
                                   extraClass = {},
                                   progress = { total: 0, uploaded: 0 },
                                   minPercent = 10,
                               }) {
    const classes = useMemo(() => classNames({
        btn: true,
        'btn-loading': true,
        'btn-default': isDefault,
        'btn-primary': primary,
        'btn-white': white,
        'btn-info': info,
        'btn-loading_active': loading,
        ...extraClass,
    }), [isDefault, primary, white, info, loading, extraClass]);

    const width = useMemo(() => {
        const t = Number(progress.total) || 0;
        const u = Number(progress.uploaded) || 0;
        if (!t) return 0;
        const pct = (u * 100) / t;
        return `${pct < minPercent ? minPercent : pct}%`;
    }, [progress, minPercent]);

    const handleClick = useCallback(() => {
        if (loading || disabled) return;
        onClick && onClick();
    }, [loading, disabled, onClick]);

    return (
        <button type={type} className={classes} disabled={disabled || loading} onClick={handleClick}>
            <span className="btn-loading__label">{text}</span>
            <span className="btn-loading__spiner"><Loading white inherit /></span>
            <span className="btn-loading__progress" style={{ width }} />
        </button>
    );
}

Button.propTypes = {
    type: PropTypes.string,
    text: PropTypes.node,
    onClick: PropTypes.func,
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    default: PropTypes.bool,
    primary: PropTypes.bool,
    white: PropTypes.bool,
    info: PropTypes.bool,
    extraClass: PropTypes.object,
    progress: PropTypes.shape({ total: PropTypes.number, uploaded: PropTypes.number }),
    minPercent: PropTypes.number,
};
